import { HttpParams } from '@angular/common/http';
import { debounceTime } from 'rxjs/operators';
import { SearchResponse } from './../../../models/search-response';
import { SearchService } from './../search/search.service';
import { Subject } from 'rxjs';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'pdp-search-two',
    templateUrl: './search-two.component.html',
    styleUrls: ['./search-two.component.scss'],
    imports: [FormsModule, ReactiveFormsModule]
})

export class SearchTwoComponent {
  private unsubscribe: Subject<void> = new Subject();
  public formGroup: UntypedFormGroup;

  public searchResponse: SearchResponse;
  constructor(public activatedRoute: ActivatedRoute,
    public router: Router,
    private searchService: SearchService,
    public formBuilder: UntypedFormBuilder) {
    this.formGroup = this.formBuilder.group({
      'searchInput': new UntypedFormControl()
    })
    this.formGroup
      .valueChanges
      .pipe(
        debounceTime(200),
        takeUntil(this.unsubscribe))
      .subscribe((fieldChanged: any) => {
        const query: string = fieldChanged['searchInput']

        if (typeof query === 'string') {
          let httpParams: HttpParams = new HttpParams();
          httpParams = httpParams.append('q', query);
          httpParams = httpParams.append('size', 5 + '');
          this.searchService.performSearch(httpParams).pipe(
            takeUntil(this.unsubscribe))
            .subscribe((searchResponse: SearchResponse) => {
              this.searchResponse = searchResponse;
            });
        }
      })
  }

  public doSearch() {
    let value = this.formGroup.value['searchInput'];

    if (value) {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          'q': value,
          'page': '0',
          'size': '30',
          'sortBy': 'price',
          'sortOrder': 'asc'
        },
        relativeTo: this.activatedRoute
      };
      value = '';
      this.router.navigate(['/search'], navigationExtras);
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}